export function shouldLoadScripts() {
    return !navigator.userAgent.includes('Lighthouse');
 };
 
 export function registerGlobal(scripts) {
     Object.keys(scripts).map((scriptName) => {
         window[scriptName] = scripts[scriptName]
     })
 }
 
 export function asset(path) {
     return `${assetsPath.trim('/')}/${path.trim('/')}`;
 }
 
 export function changeImportFile() {
     const importFileBtn = document.getElementById('importFile');
 
     if (!importFileBtn) return;
 
     const hiddenImportWrapper = document.getElementById('hidden-form-wrapper');
     const hiddenImportField = document.querySelector('[name="import_file"]');
     const fileName = document.getElementById('importFileName');
     
     hiddenImportWrapper.style.display = 'none';
 
     if (hiddenImportField.files.length) {
         fileName.innerHTML = hiddenImportField.files[0].name;
     } else if(hiddenImportField) {
         fileName.innerHTML = __('Nie wybrano pliku.');
     }
 
     importFileBtn.addEventListener('click', (e) => {
         e.preventDefault();
         hiddenImportField.click();
     });
 
     hiddenImportField.addEventListener('change', (e) => {
         fileName.innerHTML = e.target.files[0].name;
     });
 }

 export function isMobile() {
    return window.innerWidth <= 1024;
}

export function isPreview() {
    return document.body.classList.contains('is-preview');
}

